export const icons = {
  国語: require('@/assets/img/book.png'),
  算数: require('@/assets/img/scale.png'),
  思考の達人ツール: require('@/assets/img/setting.png'),
  複合教科問題: require('@/assets/img/fukugou.png'),
  添削テスト: require('@/assets/img/scale.png'),
  えい語: require('@/assets/img/al.png'),
  会報誌: require('@/assets/img/book.png'),
  ひらめき図形ブロック: require('@/assets/img/scale.png'),
  表紙: require('@/assets/img/book.png'),
  english_gray: require('@/assets/img/ai_gray.png'),
  star: require('@/assets/img/star.png')
} as const
